module.exports = __webpack_public_path__ + "assets/img/list.7480a9bb.svg";